import { environment } from "src/environments/environment";

export class CampaignEvaluationRequest{
    appName: string = environment.appName;
    
}